import { useMemo } from 'react';
import { MarkerContainerProps } from './types';

const MarkerContainer: React.FunctionComponent<MarkerContainerProps> = ({
  color,
  children,
  height = 26,
  width = 22,
  left = 0,
  top = 0,
  hasPointer = true,
}) => {
  const style = useMemo(() => {
    return {
      container: {
        position: 'relative' as any,
        height,
        width,
        left,
        top,
      },
      shape: {
        '--marker-color': color,
        background: color,
        position: 'relative' as any,
        height: height - 6,
        width: width,
        boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.4)',
        borderRadius: 2,
      },
      icon: {
        '--marker-color': color,
        height: height - 6,
        width: width,
        position: 'relative' as any,
        top: 0,
        left: 0,
      },
    };
  }, [color, height, left, top, width]);
  // inline styles are required other wise different markup is called

  return (
    <div style={style.container}>
      <div className={hasPointer ? 'marker-container-shape' : undefined} style={style.shape}>
        {children !== undefined ? (
          <div className='marker-container-icon' style={style.icon}>
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MarkerContainer;
